import { isResourceDetailDocumentPDF } from '../../resources/documentGuards.js';
import { isResourceDetailNotepad } from '../../resources/utils/resourceDetailGuards.js';

const getWillRegisterSubdocumentSearch = (resource) => {
  return isResourceDetailNotepad(resource) || isResourceDetailDocumentPDF(resource);
};

export { getWillRegisterSubdocumentSearch };
//# sourceMappingURL=getWillRegisterSubdocumentSearch.js.map
